<script>
    import Posts from '~/components/Posts.svelte';
    import Editor from '~/components/Editor.svelte';

    import { navigate } from 'svelte-routing';
    import { isAdmin } from '~/firebase';

    let addingPost = false;
    
    function addedPost(e) {
        navigate(`/post/${e.detail.id}`);
    }
</script>

{#if addingPost}
    {#if $isAdmin}
        <Editor on:cancel={() => addingPost = false} on:done={addedPost}/>
    {/if}
{:else}
    {#if $isAdmin}
        <a href="javascript:void(0);" on:click={() => addingPost = true}>Add new post</a>
    {/if}
    <Posts title="Blog" />
{/if}
